import axiosAuth from '../../../shared/configs/axios-auth'
import router from '@/router'
import { store } from '@/store'
const getDefaultState = () => {
    // Initialize from localStorage to support page refresh
    const token = localStorage.getItem('token')
    const isAdmin = localStorage.getItem('isAdmin') === 'true'
    const adminSimulated = localStorage.getItem('admin_simulated') === 'true'
    const ownManagerId = localStorage.getItem('ownManagerId') || null
    const hasToken = token && token.length > 10
    
    // Load context from localStorage if token exists (user is logged in)
    // Context will be validated in userInformations action
    // Only clear if no token (user not logged in)
    let currentForManagerId = null;
    let currentForManagerName = null;
    let currentRole = null;
    
    if (hasToken) {
        // Load context from localStorage - will be validated in userInformations
        currentForManagerId = localStorage.getItem('currentForManagerId') || null;
        currentForManagerName = localStorage.getItem('currentForManagerName') || null;
        currentRole = localStorage.getItem('currentRole') || null;
    } else {
        // Clear context if no token (user not logged in)
        localStorage.removeItem('currentForManagerId')
        localStorage.removeItem('currentForManagerName')
        localStorage.removeItem('currentRole')
    }
    
    
    return {
        trash: null,
        users: [],
        authMessage: "",
        codeSent: null,
        updatingAuth: false,
        accountCreated: null,
        accountCompleted: null,
        loggedIn: hasToken,  // Initialize from localStorage
        userName: '',
        userMail: '',
        idToken: token,
        userId: null,
        errorCode: null,
        logOutTimer: null,
        resetOk: false,
        verificationSent: false,
        emailVerified: null,
        userInformations: null,
        userCreated: null,
        passwordSent: false,
        passwordResetSuccessful: false,
        updatingAccountDelete: false,
        deleteCodeSent: false,
        isSwitchingContext: false,
        deleteMessage: '',
        deleteSuccess: false,
        // Neue Felder für Rollen-System (initialize from localStorage)
        managerRoles: [],
        currentForManagerId: currentForManagerId,
        currentForManagerName: currentForManagerName,
        currentRole: currentRole,
        hasMultipleManagers: false,
        isAdmin: isAdmin,  // Initialize from localStorage
        adminSimulated: adminSimulated,  // Initialize from localStorage
        ownManagerId: ownManagerId,  // Initialize from localStorage
        // Guard für redundante API-Calls
        fetchingUserInfo: false
    }
}

const state = getDefaultState()

const getters = {
    authMessage: state => {
        return state.authMessage;
    },
    updatingAccountDelete: state => {
        return state.updatingAccountDelete;
    },
    deleteCodeSent: state => {
        return state.deleteCodeSent;
    },
    deleteSuccess: state => {
        return state.deleteSuccess;
    },
    deleteMessage: state => {
        return state.deleteMessage;
    },
    passwordSent: state => {
        return state.passwordSent;
    },
    passwordResetSuccessful: state => {
        return state.passwordResetSuccessful;
    },
    codeSent: state => {
        return state.codeSent;
    },
    accountCreated: state => {
        return state.accountCreated;
    },
    userId: state => {
        return state.userId;
    },
    users: state => {
        return state.users;
    },
    userCreated: state => {
        return state.userCreated;
    },
    accountCompleted: state => {
        return state.accountCompleted;
    },
    emailVerified: state => {
        return state.emailVerified;
    },
    verificationSent: state => {
        return state.verificationSent;
    },
    loggedIn: state => {
        return state.loggedIn;
    },
    userName: state => {
        return state.userName;
    },
    userMail: state => {
        return state.userMail;
    },
    updatingAuth: state => {
        return state.updatingAuth;
    },
    isSwitchingContext: state => {
        return state.isSwitchingContext;
    },
    authError: state => {
        return state.errorCode;
    },
    logOutTimer: state => {
        return state.logOutTimer;
    },
    resetOk: state => {
        return state.resetOk;
    },
    idToken: state => {
        return state.idToken
    },
    userInformations: state => {
        return state.userInformations
    },
    // Neue Getters für Rollen-System
    managerRoles: state => state.managerRoles,
    currentForManagerId: state => state.currentForManagerId,
    currentForManagerName: state => state.currentForManagerName,
    currentRole: state => state.currentRole,
    hasMultipleManagers: state => state.hasMultipleManagers,
    isAdmin: state => state.isAdmin, // TRUE für echte Admins UND simulierte Admins (User mit Rollen)
    adminSimulated: state => state.adminSimulated, // TRUE nur für simulierte Admins
    isRealAdmin: state => state.isAdmin && !state.adminSimulated, // TRUE nur für echte Admins
    ownManagerId: state => state.ownManagerId,
    accessibleManagers: state => {
        const managers = [];
        const rolePriority = {
            'admin': 1,
            'manager': 2,
            'pos': 3,
            'checker': 4
        };

        // Eigener Manager falls ECHTER admin
        if (state.isAdmin && !state.adminSimulated && state.ownManagerId) {
            managers.push({
                id: state.ownManagerId,
                name: 'Eigene Events',
                role: 'admin',
                isOwn: true
            });
        }

        // Group roles by manager ID and keep only highest priority role per manager
        // Calculate role from booleans: canManage > canPos > canCheck
        const managerRoleMap = {};
        
        state.managerRoles.forEach(role => {
            if (role.accepted) {
                const managerId = role.forManager._id || role.forManager;
                
                // Calculate role from booleans (priority: manager > pos > checker)
                let calculatedRole = 'checker';
                if (role.canManage === true) {
                    calculatedRole = 'manager';
                } else if (role.canPos === true) {
                    calculatedRole = 'pos';
                } else if (role.canCheck === true) {
                    calculatedRole = 'checker';
                }
                
                const currentPriority = rolePriority[calculatedRole] || 999;
                
                // If manager not in map OR current role has higher priority
                if (!managerRoleMap[managerId] || 
                    currentPriority < (rolePriority[managerRoleMap[managerId].role] || 999)) {
                    managerRoleMap[managerId] = {
                        id: managerId,
                        name: role.forManager.companyName || `${role.forManager.firstname} ${role.forManager.lastname}` || role.forManager.email,
                        role: calculatedRole,
                        isOwn: false
                    };
                }
            }
        });
        
        // Add unique managers to array
        Object.values(managerRoleMap).forEach(manager => {
            managers.push(manager);
        });

        // Sort by role priority: admin > manager > pos > checker
        managers.sort((a, b) => {
            const priorityA = rolePriority[a.role] || 999;
            const priorityB = rolePriority[b.role] || 999;
            return priorityA - priorityB;
        });

        return managers;
    },
    hasRoleForManager: state => (forManagerId, requiredRole) => {
        // ECHTER Admin kann alles für eigene Events
        if (state.isAdmin && !state.adminSimulated && forManagerId === state.ownManagerId) {
            return true;
        }

        // Prüfe ManagerRole - based on booleans only
        const role = state.managerRoles.find(r =>
            r.forManager._id === forManagerId || r.forManager === forManagerId
        );

        if (!role || !role.accepted) return false;

        // Rollen-Hierarchie basierend auf Booleans: canManage kann alles, canPos kann pos und checker, canCheck nur checker
        if (requiredRole === 'manager') return role.canManage === true;
        if (requiredRole === 'pos') return role.canManage === true || role.canPos === true;
        if (requiredRole === 'checker') return role.canManage === true || role.canPos === true || role.canCheck === true;

        return false;
    },
    // Current role and manager context - calculate from booleans if not set
    currentRole: (state) => {
        // If currentRole is already set and valid, return it
        if (state.currentRole && ['admin', 'manager', 'pos', 'checker'].includes(state.currentRole)) {
            return state.currentRole;
        }
        
        // Calculate from current manager's role booleans
        if (state.currentForManagerId && state.managerRoles) {
            const role = state.managerRoles.find(r => {
                const forManagerId = r.forManager._id || r.forManager;
                return forManagerId === state.currentForManagerId && r.accepted;
            });
            
            if (role) {
                // Calculate role from booleans (priority: manager > pos > checker)
                if (role.canManage === true) return 'manager';
                if (role.canPos === true) return 'pos';
                if (role.canCheck === true) return 'checker';
            }
        }
        
        // Fallback: check if admin
        if (state.isAdmin && !state.adminSimulated) {
            return 'admin';
        }
        
        return state.currentRole || null;
    },
    currentForManagerName: state => {
        if (!state.currentForManagerId) return '';
        
        // Own manager
        if (state.currentForManagerId === state.ownManagerId && state.userInformations) {
            return state.userInformations.companyName || `${state.userInformations.firstname} ${state.userInformations.lastname}`;
        }
        
        // Find in managerRoles
        const role = state.managerRoles.find(r => {
            const forManagerId = r.forManager._id || r.forManager;
            return forManagerId === state.currentForManagerId;
        });
        
        if (role && role.forManager) {
            return role.forManager.companyName || `${role.forManager.firstname} ${role.forManager.lastname}`;
        }
        
        return '';
    },
    // Permission getters (based on CURRENT role - for Admin Area)
    isManager: (state, getters) => {
        // ECHTER Admin managing their own events has full manager rights
        if (state.isAdmin && !state.adminSimulated && state.currentForManagerId === state.ownManagerId) {
            return true;
        }
        // Check if current manager role has canManage boolean
        if (state.currentForManagerId && state.managerRoles) {
            const role = state.managerRoles.find(r => {
                const forManagerId = r.forManager._id || r.forManager;
                return forManagerId === state.currentForManagerId && r.accepted;
            });
            if (role && role.canManage === true) {
                return true;
            }
        }
        const result = getters.currentRole === 'admin' || getters.currentRole === 'manager';
        return result;
    },
    
    // Check if user has ANY manager role (for navigation) - based on canManage boolean only
    hasManagerRole: (state) => {
        // Check state.managerRoles first - ONLY use canManage boolean
        const stateRoles = state.managerRoles || [];
        const hasRoleInState = stateRoles.some(r => r.accepted && r.canManage === true);
        
        // Fallback: Check userInformations.managerRoles if state is empty
        if (!hasRoleInState && state.userInformations && state.userInformations.managerRoles) {
            const userRoles = state.userInformations.managerRoles || [];
            const hasRoleInUserInfo = userRoles.some(r => r.accepted && r.canManage === true);
            return hasRoleInUserInfo;
        }
        
        return hasRoleInState;
    },
    
    // Check if user has ANY POS role (for navigation) - based on canPos boolean only
    hasPosRole: (state) => {
        // Check state.managerRoles first - ONLY use canPos boolean
        const stateRoles = state.managerRoles || [];
        const hasRoleInState = stateRoles.some(r => r.accepted && r.canPos === true);
        
        // Fallback: Check userInformations.managerRoles if state is empty
        if (!hasRoleInState && state.userInformations && state.userInformations.managerRoles) {
            const userRoles = state.userInformations.managerRoles || [];
            const hasRoleInUserInfo = userRoles.some(r => r.accepted && r.canPos === true);
            return hasRoleInUserInfo;
        }
        
        return hasRoleInState;
    },
    
    // Check if user has ANY checker role (for navigation) - based on canCheck boolean only
    hasCheckerRole: (state) => {
        // Check state.managerRoles first - ONLY use canCheck boolean
        const stateRoles = state.managerRoles || [];
        const hasRoleInState = stateRoles.some(r => r.accepted && r.canCheck === true);
        
        // Fallback: Check userInformations.managerRoles if state is empty
        if (!hasRoleInState && state.userInformations && state.userInformations.managerRoles) {
            const userRoles = state.userInformations.managerRoles || [];
            const hasRoleInUserInfo = userRoles.some(r => r.accepted && r.canCheck === true);
            return hasRoleInUserInfo;
        }
        
        return hasRoleInState;
    },
    isPosUser: (state, getters) => {
        // ECHTER Admin managing their own events has full POS rights
        if (state.isAdmin && !state.adminSimulated && state.currentForManagerId === state.ownManagerId) {
            return true;
        }
        // Check if current manager role has canPos or canManage boolean
        if (state.currentForManagerId && state.managerRoles) {
            const role = state.managerRoles.find(r => {
                const forManagerId = r.forManager._id || r.forManager;
                return forManagerId === state.currentForManagerId && r.accepted;
            });
            if (role && (role.canPos === true || role.canManage === true)) {
                return true;
            }
        }
        const result = getters.currentRole === 'pos' || getters.currentRole === 'admin' || getters.currentRole === 'manager';
        return result;
    },
    isChecker: (state, getters) => {
        // ECHTER Admin managing their own events has full checker rights
        if (state.isAdmin && !state.adminSimulated && state.currentForManagerId === state.ownManagerId) {
            return true;
        }
        // Check if current manager role has canCheck, canPos or canManage boolean
        if (state.currentForManagerId && state.managerRoles) {
            const role = state.managerRoles.find(r => {
                const forManagerId = r.forManager._id || r.forManager;
                return forManagerId === state.currentForManagerId && r.accepted;
            });
            if (role && (role.canCheck === true || role.canPos === true || role.canManage === true)) {
                return true;
            }
        }
        const result = getters.currentRole === 'checker' || getters.currentRole === 'pos' || getters.currentRole === 'admin' || getters.currentRole === 'manager';
        return result;
    },
    canCreateEvents: (state, getters) => {
        // Only REAL admin managers can create events for their own organization
        return state.isAdmin && !state.adminSimulated && state.currentForManagerId === state.ownManagerId;
    },
    canSendInvitations: (state, getters) => {
        // Only REAL admins can send invitations
        return state.isAdmin && !state.adminSimulated;
    },
    canManageInvitations: (state, getters) => {
        // Only REAL admins can manage invitations
        return state.isAdmin && !state.adminSimulated;
    },
    canManageRoles: (state, getters) => {
        // Only REAL admins can manage roles
        return state.isAdmin && !state.adminSimulated;
    },
    canArchiveEvents: (state, getters) => {
        return getters.isManager;
    },
    canHardDeleteEvents: (state, getters) => {
        // Only REAL admins can hard delete events
        return state.isAdmin && !state.adminSimulated;
    },
    canManageEvents: state => forManagerId => {
        // REAL admin for own events OR canManage boolean
        return (state.isAdmin && !state.adminSimulated && forManagerId === state.ownManagerId) ||
               state.managerRoles.some(r =>
                   (r.forManager._id === forManagerId || r.forManager === forManagerId) &&
                   r.accepted && r.canManage === true
               );
    },
    canCreatePosTickets: state => forManagerId => {
        // canPos OR canManage (manager can also create POS tickets)
        return state.managerRoles.some(r =>
            (r.forManager._id === forManagerId || r.forManager === forManagerId) &&
            r.accepted && (r.canPos === true || r.canManage === true)
        );
    },
    canScanTickets: state => forManagerId => {
        // canCheck OR canPos OR canManage (hierarchy)
        return (state.isAdmin && !state.adminSimulated && forManagerId === state.ownManagerId) ||
               state.managerRoles.some(r =>
                   (r.forManager._id === forManagerId || r.forManager === forManagerId) &&
                   r.accepted && (r.canCheck === true || r.canPos === true || r.canManage === true)
               );
    },
}

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState())
    },
    updatingAccountDelete: (state, payload) => {
        state.updatingAccountDelete = payload
    },
    deleteCodeSent: (state, payload) => {
        state.deleteCodeSent = payload
    },
    deleteMessage: (state, payload) => {
        state.deleteMessage = payload
    },
    deleteSuccess: (state, payload) => {
        state.deleteSuccess = payload
    },
    // Neue Mutations für Rollen-System
    managerRoles: (state, payload) => {
        state.managerRoles = payload || []
    },
    currentForManagerId: (state, payload) => {
        state.currentForManagerId = payload
    },
    currentForManagerName: (state, payload) => {
        state.currentForManagerName = payload
    },
    currentRole: (state, payload) => {
        state.currentRole = payload
    },
    hasMultipleManagers: (state, payload) => {
        state.hasMultipleManagers = payload
    },
    isAdmin: (state, payload) => {
        state.isAdmin = payload
    },
    adminSimulated: (state, payload) => {
        state.adminSimulated = payload
    },
    ownManagerId: (state, payload) => {
        state.ownManagerId = payload
    },
    authMessage: (state, payload) => {
        state.authMessage = payload
    },
    passwordResetSuccessful: (state, payload) => {
        state.passwordResetSuccessful = payload
    },
    passwordSent: (state, payload) => {
        state.passwordSent = payload
    },
    trash: (state, payload) => {
        state.trash = payload
    },
    users: (state, payload) => {
        state.users = payload
    },
    userCreated: (state, payload) => {
        state.userCreated = payload
    },
    updatingAuth: (state, payload) => {
        state.updatingAuth = payload
    },
    isSwitchingContext: (state, payload) => {
        state.isSwitchingContext = payload
    },
    codeSent: (state, payload) => {
        state.codeSent = payload
    },
    accountCreated: (state, bool) => {
        state.accountCreated = bool
    },
    accountCompleted: (state, bool) => {
        state.accountCompleted = bool
    },
    emailVerified: (state, bool) => {
        state.emailVerified = bool
    },
    verificationSent: (state, bool) => {
        state.verificationSent = bool
    },
    loggedIn: (state, bool) => {
        state.loggedIn = bool;
    },
    resetOk: (state, bool) => {
        state.resetOk = bool
    },
    logOut: (state) => {
        state.loggedIn = false;
        state.userName = null
    },
    userName: (state, payload) => {
        state.userName = payload
    },
    authUser(state, userData) {
        state.idToken = userData.token
        state.userId = userData.userId
        state.userName = userData.userName
        state.loggedIn = true
    },
    authError(state, error) {
        state.errorCode = error
    },
    userInformations(state, error) {
        state.userInformations = error
    },
    clearAuthData(state) {
        state.idToken = null
        state.userName = null
        state.userId = null
        state.logOutTimer = null
        clearInterval(this.interval)
        state.resetOk = false
    }
}

const actions = {

    tryAutoLogin({ commit, dispatch }) {
        var token = localStorage.getItem('token')
        if (!token) return;
        if (token) {
            if (token.length > 10) {
                dispatch('userInformations')
                state.idToken = token
                commit('authUser', {
                    token: token
                })
                axiosAuth.defaults.headers["Authorization"] = token
                return
            }
        } else {
            if (localStorage.getItem('darkMode')) {
                commit('darkMode', !localStorage.getItem('darkMode'))
            }
            dispatch('logout')
        }

    },

    signup({ commit, dispatch }, authData) {
        commit('accountCreated', null)
        commit('authError', null)
        commit('authMessage', '')
        commit('updatingAuth', true)
        axiosAuth.post('/authnews/register', authData)
            .then(
                res => {
                    commit('trash', res)
                    commit('updatingAuth', false)
                    commit('accountCreated', true)
                    dispatch('loginModal', authData)
                }
            )
            .catch(
                error => {
                    commit('authMessage', error.response.data)
                    commit('accountCreated', false)
                    commit('authError', error.response.status)
                    commit('updatingAuth', false)
                }
            )
    },

    requestDeleteAccount({ commit }) {
        commit('updatingAccountDelete', true)
        commit('deleteCodeSent', false)
        axiosAuth.post('/authnews/deleteAccount')
            .then(
                res => {
                    commit('updatingAccountDelete', false)
                    commit('deleteCodeSent', true)

                }
            )
            .catch(
                error => {
                    commit('updatingAccountDelete', false)
                    commit('deleteCodeSent', false)
                }
            )
    },

    confirmDeleteAccount({ commit, dispatch }, code) {
        commit('updatingAccountDelete', true)
        commit('deleteSuccess', false)
        axiosAuth.post('/authnews/verifyAccountDelete', { verificationCode: code })
            .then(
                res => {
                    commit('updatingAccountDelete', false)
                    commit('deleteSuccess', true)
                    dispatch("logout");
                }
            )
            .catch(
                error => {
                    commit('updatingAccountDelete', false)
                    commit('deleteMessage', error.response.data)
                    commit('deleteSuccess', false)
                }
            )
    },

    verifyEmail({ commit, dispatch }, authData) {
        commit('authError', null)
        commit('authMessage', '')
        commit('updatingAuth', true)
        commit('accountCompleted', null)
        axiosAuth.post('/authnews/verifyemailapp', authData)
            .then(
                res => {
                    commit('trash', res)
                    commit('updatingAuth', false)
                    commit('accountCompleted', true)
                    dispatch('userInformations')
                }
            )
            .catch(
                error => {
                    commit('authMessage', error.response.data)
                    commit('authError', error.response.status)
                    commit('updatingAuth', false)
                    commit('accountCompleted', false)
                }
            )
    },

    resendCode({ commit, dispatch }) {
        commit('authError', null)
        commit('authMessage', '')
        commit('updatingAuth', true)
        commit('codeSent', null)
        axiosAuth.post('/authnews/verificationcode')
            .then(
                res => {
                    commit('trash', res)
                    commit('updatingAuth', false)
                    commit('codeSent', true)
                    dispatch('userInformations')
                }
            )
            .catch(
                error => {
                    commit('authMessage', error.response.data)
                    commit('authError', error.response.status)
                    commit('updatingAuth', false)
                    commit('codeSent', false)
                }
            )
    },

    createAccount({ commit, dispatch }, payload) {
        commit('accountCreated', null)
        commit('authError', null)
        commit('authMessage', '')
        commit('updating', true)
        axiosAuth.post('/authnews/verifyemail', payload)
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                    commit('accountCreated', true)
                    localStorage.setItem('token', res.data.token)
                    axiosAuth.defaults.headers["Authorization"] = res.data.token;

                    dispatch('userInformations')
                    commit('updating', false)
                    router.push('/profil').catch(() => { })
                }
            )
            .catch(
                error => {
                    commit('authMessage', error.response.data)
                    commit('accountCreated', false)
                    commit('authError', error.response.status)
                    commit('updating', false)
                }
            )
    },

    createAccount({ commit, dispatch }, payload) {
        commit('accountCreated', null)
        commit('authError', null)
        commit('authMessage', '')
        commit('updating', true)
        axiosAuth.post('/authnews/verifyemail', payload)
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                    commit('accountCreated', true)
                    localStorage.setItem('token', res.data.token)
                    axiosAuth.defaults.headers["Authorization"] = res.data.token;

                    dispatch('userInformations')
                    commit('updating', false)
                    router.push('/profil').catch(() => { })
                }
            )
            .catch(
                error => {
                    commit('authMessage', error.response.data)
                    commit('accountCreated', false)
                    commit('authError', error.response.status)
                    commit('updating', false)
                }
            )
    },

    // resetPassword({ commit }, authData) {
    //     commit('accountCreated', null)
    //     commit('authError', null)
    //     commit('authMessage', '')
    //     commit('updating', true)
    //     axiosAuth.post('/authnews/resetpassword', {
    //             email: authData.email,
    //         })
    //         .then(
    //             res => {
    //                 commit('trash', res)
    //                 commit('updating', false)
    //             }
    //         )
    //         .catch(
    //             error => {
    //                 console.log(error.response)
    //                 commit('authMessage', error.response.data)
    //                 commit('authError', error.response.status)
    //                 commit('updating', false)
    //             }
    //         )
    // },

    userInformations({ commit, dispatch, state }) {
        // Guard: Prüfen ob bereits ein Request läuft
        if (state.fetchingUserInfo) {
            return Promise.resolve();
        }
        
        commit('authError', null)
        commit('authMessage', '')
        commit('updating', true)
        state.fetchingUserInfo = true;
        
        return axiosAuth.get('/authnews/me')
            .then(
                res => {
                    commit('updating', false)
                    state.fetchingUserInfo = false;
                    
                    // Set isAdmin state and localStorage
                    const isAdmin = res.data.admin || false;
                    const adminSimulated = res.data.admin_simulated || false;
                    commit('isAdmin', isAdmin)
                    commit('adminSimulated', adminSimulated)
                    
                    if (isAdmin) {
                        localStorage.setItem('admin', 'true');
                        localStorage.setItem('isAdmin', 'true');
                    } else {
                        localStorage.removeItem('admin');
                        localStorage.removeItem('isAdmin');
                    }
                    
                    if (adminSimulated) {
                        localStorage.setItem('admin_simulated', 'true');
                    } else {
                        localStorage.removeItem('admin_simulated');
                    }

                    // Set ownManagerId
                    if (res.data._id) {
                        commit('ownManagerId', res.data._id);
                        localStorage.setItem('ownManagerId', res.data._id);
                    }

                    // Process manager roles (same as login)
                    // Always set managerRoles, even if empty array
                    if (res.data.managerRoles) {
                        commit('managerRoles', res.data.managerRoles)
                        
                        // WAIT for commit to complete, then access getter
                        // Use Vue.nextTick equivalent or direct calculation
                        const rolePriority = {
                            'admin': 1,
                            'manager': 2,
                            'pos': 3,
                            'checker': 4
                        };
                        
                        // Build and sort accessible managers manually
                        // Calculate role from booleans (priority: manager > pos > checker)
                        const managerRoleMap = {};
                        res.data.managerRoles.forEach(role => {
                            if (role.accepted) {
                                const managerId = role.forManager._id || role.forManager;
                                
                                // Calculate role from booleans
                                let calculatedRole = 'checker';
                                if (role.canManage === true) {
                                    calculatedRole = 'manager';
                                } else if (role.canPos === true) {
                                    calculatedRole = 'pos';
                                } else if (role.canCheck === true) {
                                    calculatedRole = 'checker';
                                }
                                
                                const currentPriority = rolePriority[calculatedRole] || 999;
                                
                                if (!managerRoleMap[managerId] || 
                                    currentPriority < (rolePriority[managerRoleMap[managerId].role] || 999)) {
                                    managerRoleMap[managerId] = {
                                        id: managerId,
                                        name: role.forManager.companyName || `${role.forManager.firstname} ${role.forManager.lastname}` || role.forManager.email,
                                        role: calculatedRole
                                    };
                                }
                            }
                        });
                        
                        let accessibleManagers = Object.values(managerRoleMap).sort((a, b) => {
                            const priorityA = rolePriority[a.role] || 999;
                            const priorityB = rolePriority[b.role] || 999;
                            return priorityA - priorityB;
                        });
                        
                        const ownManagerId = res.data._id
                        const isAdmin = res.data.admin || false
                        const adminSimulated = res.data.admin_simulated || false
                        const isRealAdmin = isAdmin && !adminSimulated
                        
                        // Add own manager to accessibleManagers if real admin (same logic as getter)
                        if (isRealAdmin && ownManagerId) {
                            const ownManagerExists = accessibleManagers.some(m => m.id === ownManagerId);
                            if (!ownManagerExists) {
                                accessibleManagers.unshift({
                                    id: ownManagerId,
                                    name: res.data.companyName || res.data.name || 'Eigene Events',
                                    role: 'admin',
                                    isOwn: true
                                });
                            }
                        }
                        
                        
                        // Check if own manager is in accessibleManagers
                        const ownManagerInList = accessibleManagers.some(m => m.id === ownManagerId);
                        
                        // Count external managers (excluding own manager)
                        const externalManagers = accessibleManagers.filter(m => m.id !== ownManagerId);
                        const hasExternalManagers = externalManagers.length > 0
                        
                        // hasMultipleManagers: true if user has external managers with permissions OR is admin with own manager
                        // This ensures the menu is always shown when external managers are available OR when admin has own context
                        commit('hasMultipleManagers', hasExternalManagers || (isRealAdmin && ownManagerInList))
                        
                        const currentForManagerId = localStorage.getItem('currentForManagerId')
                        
                        
                        // ALWAYS work with context - preserve external context if valid
                        if (currentForManagerId && currentForManagerId !== ownManagerId) {
                            // Context is external - validate it's still accessible (has permissions)
                            const isValidContext = accessibleManagers.some(m => m.id === currentForManagerId);
                            if (!isValidContext) {
                                // External context not accessible (no permissions) - fallback logic
                                if (isAdmin && ownManagerInList) {
                                    // Admin: fallback to own manager
                                    commit('currentForManagerId', ownManagerId);
                                    commit('currentForManagerName', res.data.companyName || res.data.name || 'Eigener Bereich');
                                    commit('currentRole', 'admin');
                                    localStorage.setItem('currentForManagerId', ownManagerId);
                                    localStorage.setItem('currentForManagerName', res.data.companyName || res.data.name || 'Eigener Bereich');
                                    localStorage.setItem('currentRole', 'admin');
                                } else if (externalManagers.length > 0) {
                                    // Non-admin: fallback to first external manager
                                    const firstExternal = externalManagers[0];
                                    commit('currentForManagerId', firstExternal.id);
                                    commit('currentForManagerName', firstExternal.name);
                                    commit('currentRole', firstExternal.role);
                                    localStorage.setItem('currentForManagerId', firstExternal.id);
                                    localStorage.setItem('currentForManagerName', firstExternal.name);
                                    localStorage.setItem('currentRole', firstExternal.role);
                                } else {
                                    // No accessible managers - clear context
                                    commit('currentForManagerId', null);
                                    commit('currentForManagerName', null);
                                    commit('currentRole', null);
                                    localStorage.removeItem('currentForManagerId');
                                    localStorage.removeItem('currentForManagerName');
                                    localStorage.removeItem('currentRole');
                                }
                            } else {
                                // Update to current manager's highest priority role
                                const currentManager = accessibleManagers.find(m => m.id === currentForManagerId);
                                if (currentManager) {
                                    commit('currentForManagerId', currentManager.id);
                                    commit('currentForManagerName', currentManager.name);
                                    commit('currentRole', currentManager.role);
                                    localStorage.setItem('currentForManagerId', currentManager.id);
                                    localStorage.setItem('currentForManagerName', currentManager.name);
                                    localStorage.setItem('currentRole', currentManager.role);
                                }
                            }
                        } else if (!currentForManagerId) {
                            // No context set - set based on user type
                            if (isAdmin && ownManagerInList) {
                                // Admin: set to own manager
                                commit('currentForManagerId', ownManagerId);
                                commit('currentForManagerName', res.data.companyName || res.data.name || 'Eigener Bereich');
                                commit('currentRole', 'admin');
                                localStorage.setItem('currentForManagerId', ownManagerId);
                                localStorage.setItem('currentForManagerName', res.data.companyName || res.data.name || 'Eigener Bereich');
                                localStorage.setItem('currentRole', 'admin');
                            } else if (externalManagers.length > 0) {
                                // Non-admin: set to first external manager
                                const firstExternal = externalManagers[0];
                                commit('currentForManagerId', firstExternal.id);
                                commit('currentForManagerName', firstExternal.name);
                                commit('currentRole', firstExternal.role);
                                localStorage.setItem('currentForManagerId', firstExternal.id);
                                localStorage.setItem('currentForManagerName', firstExternal.name);
                                localStorage.setItem('currentRole', firstExternal.role);
                            } else {
                                // No accessible managers - clear context
                                console.log('🧹 [USER INFO] No accessible managers, clearing context')
                                commit('currentForManagerId', null);
                                commit('currentForManagerName', null);
                                commit('currentRole', null);
                                localStorage.removeItem('currentForManagerId');
                                localStorage.removeItem('currentForManagerName');
                                localStorage.removeItem('currentRole');
                            }
                        } else {
                            // Context is own manager - validate if user can access it
                            if (isAdmin && ownManagerInList) {
                                // Admin: keep own context
                                commit('currentForManagerId', ownManagerId);
                                commit('currentForManagerName', res.data.companyName || res.data.name || 'Eigener Bereich');
                                commit('currentRole', 'admin');
                                localStorage.setItem('currentForManagerId', ownManagerId);
                                localStorage.setItem('currentForManagerName', res.data.companyName || res.data.name || 'Eigener Bereich');
                                localStorage.setItem('currentRole', 'admin');
                            } else if (externalManagers.length > 0) {
                                // Non-admin: switch to first external manager
                                const firstExternal = externalManagers[0];
                                commit('currentForManagerId', firstExternal.id);
                                commit('currentForManagerName', firstExternal.name);
                                commit('currentRole', firstExternal.role);
                                localStorage.setItem('currentForManagerId', firstExternal.id);
                                localStorage.setItem('currentForManagerName', firstExternal.name);
                                localStorage.setItem('currentRole', firstExternal.role);
                            } else {
                                // No accessible managers - clear context
                                console.log('🧹 [USER INFO] No accessible managers, clearing context')
                                commit('currentForManagerId', null);
                                commit('currentForManagerName', null);
                                commit('currentRole', null);
                                localStorage.removeItem('currentForManagerId');
                                localStorage.removeItem('currentForManagerName');
                                localStorage.removeItem('currentRole');
                            }
                        }
                    }

                    if (!res.data.adressData) {
                        res.data.adressData = {}
                    }
                    commit('userInformations', res.data)
                    //commit('loggedIn', true)

                }
            )
            .catch(
                error => {
                    state.fetchingUserInfo = false;
                    commit('authMessage', error.response.data)
                    commit('authError', error.response.status)
                    commit('updating', false)
                    // dispatch('logout')
                }
            )
    },

    updateUserInformations: ({ commit, dispatch }, payload) => {
        commit('updating', true)
        axiosAuth.patch('/authnews/me', payload)
            .then(
                res => {
                    commit('updating', false)
                    dispatch('userInformations')
                }
            )
            .catch(
                error => {
                    commit('updating', false)
                }
            )
    },

    login({ commit, dispatch }, authData) {
        commit('authError', null)
        commit('authMessage', '')
        commit('updating', true)
        axiosAuth.post('/authnews/login', {
            email: authData.email,
            password: authData.password
        })
            .then(
                res => {
                    commit('loggedIn', true)
                    
                    commit('resetState')
                    state.idToken = res.data.token
                    commit('authUser', {
                        token: res.data.token,
                        userId: res.data.id,
                        userMail: res.data.email,
                        userName: res.data.name
                    })

                    // Neue Felder für Rollen-System setzen
                    const isAdmin = res.data.isAdmin || false
                    const adminSimulated = res.data.admin_simulated || false
                    
                    
                    commit('managerRoles', res.data.managerRoles || [])
                    commit('isAdmin', isAdmin)
                    commit('adminSimulated', adminSimulated)
                    commit('ownManagerId', res.data.id)
                    

                    // Use SORTED accessibleManagers from getter (includes priority logic)
                    const accessibleManagers = getters.accessibleManagers
                    
                    commit('hasMultipleManagers', accessibleManagers.length > 1)

                    // Automatisch Manager-Kontext setzen (immer die höchste Priorität wählen)
                    if (accessibleManagers.length === 1) {
                        commit('currentForManagerId', accessibleManagers[0].id)
                        commit('currentForManagerName', accessibleManagers[0].name)
                        commit('currentRole', accessibleManagers[0].role)
                    } else if (accessibleManagers.length > 1) {
                        // Auto-select highest priority role (first in sorted list)
                        commit('currentForManagerId', accessibleManagers[0].id)
                        commit('currentForManagerName', accessibleManagers[0].name)
                        commit('currentRole', accessibleManagers[0].role)
                    } else {
                        // No external managers - clear context completely
                        commit('currentForManagerId', null)
                        commit('currentForManagerName', null)
                        commit('currentRole', null)
                        commit('hasMultipleManagers', false)
                    }

                    localStorage.setItem('token', res.data.token)
                    localStorage.setItem('isAdmin', isAdmin ? 'true' : 'false')
                    localStorage.setItem('admin_simulated', adminSimulated ? 'true' : 'false')
                    localStorage.setItem('ownManagerId', res.data.id)
                    
                    // Only save context if it exists, otherwise remove it
                    if (state.currentForManagerId) {
                        localStorage.setItem('currentForManagerId', state.currentForManagerId)
                        localStorage.setItem('currentForManagerName', state.currentForManagerName || '')
                        localStorage.setItem('currentRole', state.currentRole || '')
                    } else {
                        localStorage.removeItem('currentForManagerId')
                        localStorage.removeItem('currentForManagerName')
                        localStorage.removeItem('currentRole')
                    }
                    axiosAuth.defaults.headers["Authorization"] = res.data.token;


                    dispatch('userInformations')
                    commit('updating', false)

                    // Login-Flow: Bei mehreren Managern zur Auswahl, sonst normal weiter
                    if (!authData.noredirect) {
                        const shouldSelectManager = state.hasMultipleManagers && !state.currentForManagerId
                        const targetRoute = shouldSelectManager ? '/admin/select-manager' : '/admin/analytics'
                        
                        setTimeout(() => {
                            router.push(targetRoute).catch((err) => { 
                                console.error('❌ [LOGIN] Router push failed:', err)
                            })
                        }, 100)
                    }
                }
            )
            .catch(
                error => {
                    console.error('❌ [LOGIN] ERROR:', error.response)
                    commit('updating', false)
                    commit('authError', error.response.status)
                    commit('authMessage', error.response.data)
                }
            )
    },

    // Neue Actions für Rollen-System
    loadManagerRoles({ commit }) {
        // ManagerRoles werden bereits beim Login geladen
        // Diese Action könnte für spätere Updates verwendet werden
        return Promise.resolve()
    },

    setCurrentForManager({ commit, state, getters }, forManagerId) {
        const selectedManager = getters.accessibleManagers.find(m => m.id === forManagerId);
        if (selectedManager) {
            commit('currentForManagerId', selectedManager.id);
            commit('currentForManagerName', selectedManager.name);
            commit('currentRole', selectedManager.role);
            localStorage.setItem('currentForManagerId', selectedManager.id);
            localStorage.setItem('currentForManagerName', selectedManager.name);
            localStorage.setItem('currentRole', selectedManager.role);
        } else {
            commit('currentForManagerId', null);
            commit('currentForManagerName', null);
            commit('currentRole', null);
            localStorage.removeItem('currentForManagerId');
            localStorage.removeItem('currentForManagerName');
            localStorage.removeItem('currentRole');
        }
    },

    submitResetPassword({ commit, dispatch }, authData) {
        commit('authError', null)
        commit('authMessage', '')
        commit('updatingAuth', true)
        commit('passwordSent', false)
        axiosAuth.post('/authnews/resetpassword', {
            email: authData.email
        })
            .then(
                res => {
                    commit('updatingAuth', false)
                    commit('passwordSent', true)

                }
            )
            .catch(
                error => {
                    commit('updatingAuth', false)
                    commit('authError', error.response.status)
                    commit('authMessage', error.response.data)
                    commit('passwordSent', false)
                }
            )
    },
    submitResetPasswordConfirm({ commit, dispatch }, authData) {
        commit('authError', null)
        commit('authMessage', '')
        commit('updatingAuth', true)
        commit('passwordResetSuccessful', false)
        axiosAuth.post('/authnews/reset_password_confirm', {
            passwordResetCode: authData.passwordResetCode,
            new_password: authData.password
        })
            .then(
                res => {
                    commit('updatingAuth', false)
                    commit('passwordResetSuccessful', true)

                }
            )
            .catch(
                error => {
                    commit('updatingAuth', false)
                    commit('authError', error.response.status)
                    commit('authMessage', error.response.data)
                    commit('passwordResetSuccessful', false)
                }
            )
    },
    loginModal({ commit, dispatch }, authData) {
        commit('authError', null)
        commit('authMessage', '')
        commit('updating', true)
        axiosAuth.post('/authnews/login', {
            email: authData.email,
            password: authData.password
        })
            .then(
                res => {
                    commit('loggedIn', true)
                    // commit('resetState')
                    state.idToken = res.data.token
                    commit('authUser', {
                        token: res.data.token,
                        userId: res.data.id,
                        userMail: res.data.email,
                        userName: res.data.name
                    })

                    localStorage.setItem('token', res.data.token)
                    axiosAuth.defaults.headers["Authorization"] = res.data.token;

                    dispatch('userInformations')
                    commit('updating', false)
                    // if (!authData.noredirect) {
                    //     router.push('/').catch(() => {})
                    // }

                }
            )
            .catch(
                error => {
                    commit('updating', false)
                    commit('authError', error.response.status)
                    commit('authMessage', error.response.data)
                }
            )
    },

    logout({ commit, dispatch }, data) {
        localStorage.removeItem('token');
        localStorage.removeItem('admin');
        localStorage.removeItem('isAdmin');
        localStorage.removeItem('admin_simulated');
        localStorage.removeItem('ownManagerId');
        localStorage.removeItem('currentForManagerId');
        localStorage.removeItem('currentForManagerName');
        localStorage.removeItem('currentRole');
        
        // Reset AuthStore
        commit('resetState');
        
        // Reset all other stores by directly calling their resetState mutations
        // Since modules are not namespaced, we need to access them via store._modules
        if (store._modules && store._modules.root && store._modules.root._children) {
            Object.keys(store._modules.root._children).forEach(moduleKey => {
                if (moduleKey !== 'authStore' && moduleKey !== 'authStoreConfig') {
                    try {
                        const module = store._modules.root._children[moduleKey];
                        if (module && module._rawModule && module._rawModule.mutations && module._rawModule.mutations.resetState) {
                            // Call the mutation directly on the module's state
                            module._rawModule.mutations.resetState(store.state[moduleKey]);
                        }
                    } catch (e) {
                        // Silently fail if module doesn't exist or doesn't have resetState
                    }
                }
            });
        }
        
        commit('loggedIn', false)
        commit('updating', false)
        router.push('/').catch(() => {})

    },

    logoutModal({ commit }, data) {
        localStorage.removeItem('token');
        localStorage.removeItem('admin');
        localStorage.removeItem('isAdmin');
        localStorage.removeItem('admin_simulated');
        localStorage.removeItem('ownManagerId');
        localStorage.removeItem('currentForManagerId');
        localStorage.removeItem('currentForManagerName');
        localStorage.removeItem('currentRole');
        
        // Reset AuthStore
        commit('resetState');
        
        // Reset all other stores by directly calling their resetState mutations
        // Since modules are not namespaced, we need to access them via store._modules
        if (store._modules && store._modules.root && store._modules.root._children) {
            Object.keys(store._modules.root._children).forEach(moduleKey => {
                if (moduleKey !== 'authStore' && moduleKey !== 'authStoreConfig') {
                    try {
                        const module = store._modules.root._children[moduleKey];
                        if (module && module._rawModule && module._rawModule.mutations && module._rawModule.mutations.resetState) {
                            // Call the mutation directly on the module's state
                            module._rawModule.mutations.resetState(store.state[moduleKey]);
                        }
                    } catch (e) {
                        // Silently fail if module doesn't exist or doesn't have resetState
                    }
                }
            });
        }
        
        commit('userInformations', null)
        commit('loggedIn', false)
        commit('updating', false)
        router.push('/').catch(() => {})
    },


}

export default {
    state,
    getters,
    mutations,
    actions
}